export default __webpack_public_path__ + "static/media/LogoTest.3063724c.png";